import { useEffect } from "react";
import cn from "@utils/cn";

import Page from "@components/page/Page";
import Card from "@components/card/Card";
import Icon from "@elements/Icon";

const CLASS_NAMES = cn(`
  flex
  items-center
  justify-start

  w-screen
  h-screen
  max-w-full
  p-4

  bg-circuits
  [--background-color:var(--color-amaranth-900)]
`);

const CARD_CLASS_NAMES = cn(`
  shadow-glow
  w-lg
  p-8
  md:w-2xl
  md:mt-36
`);

export default function ErrorFallbackPage(props) {
  const {
    error,
    _resetErrorBoundary,
  } = props;

  useEffect(() => {
    if (error) {
      console.error(error.message);
      window.rollbar?.error(error);
    }
  }, [error]);

  return (
    <Page className={cn(CLASS_NAMES)}>
      <Card className={cn(CARD_CLASS_NAMES)}>
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="text-center text-4xl text-amaranth-800">
            <Icon iconName="triangle-exclamation" />
          </div>

          <div className="text-center text-3xl">
            Something went wrong!
          </div>

          {error?.message && (
            <>
              <hr className="w-full" />

              <div className="text-center p-2 font-mono">
                {error.message}
              </div>
            </>
          )}
        </div>
      </Card>
    </Page>
  );
}
